import axios from 'axios';
import Constants from '../constants';
import { ISurveyNote, SurveyStep } from '../models';

const noCacheHeader = () => ({ Pragma: 'no-cache' });

export const surveyNotesUrl = (surveyId: number) => {
	return Constants.API_SURVEYNOTES_URL.replace('{surveyId}', surveyId.toString());
};

export const surveyNoteUrl = (surveyId: number, step: SurveyStep) => {
	return Constants.API_SURVEYNOTES_URL.replace('{surveyId}', surveyId.toString()) + `/${step}`;
};

export async function getSurveyNotes(surveyId: number): Promise<ISurveyNote[]> {
	const res = await axios.get(surveyNotesUrl(surveyId), { headers: noCacheHeader() });
	return res.data;
}

export async function addSurveyNote(note: ISurveyNote): Promise<ISurveyNote> {
	const res = await axios.post(surveyNotesUrl(note.surveyId), note, { headers: noCacheHeader() });
	return res.data;
}

export async function updateSurveyNote(note: ISurveyNote): Promise<ISurveyNote> {
	const res = await axios.put(surveyNoteUrl(note.surveyId, note.step), note, { headers: noCacheHeader() });
	return res.data;
}

export async function deleteSurveyNote(note: ISurveyNote): Promise<ISurveyNote> {
	const res = await axios.delete(surveyNoteUrl(note.surveyId, note.step), { headers: noCacheHeader() });
	return res.data;
}
